import React, {useState, useEffect} from 'react';
import {ChevronLeft as ChevronLeftIcon, ChevronLeft, ChevronRight, Save as SubmitIcon} from '@material-ui/icons';
import {
    Button,
    ButtonGroup,
} from '@material-ui/core';
import {instanceQuiz, postInstance} from '../../api'; 


export default function QuizTakeNav(props) {
    const [storeIndex, setStoreIndex] = useState()
    const {singlePage, topRef} = props;
    const length = props.questions.length;
    const {preview, language} = props;
    const [{currentIndex, prevDisabled, nextDisabled, showReview}, setNav] = useState({
        currentIndex: 0,
        prevDisabled: !currentIndex,
        nextDisabled: length < 2,
        showReview: false,
    });

    const resetScroll = () => topRef.current.scrollIntoView();

    const nextQuestion = () => {
        const nextIndex = !singlePage ? length - 1 : currentIndex + 1;
        setNav({
            prevDisabled: nextIndex < 1,
            nextDisabled: nextIndex === (length - 1),
            currentIndex: nextIndex,
        });
        resetScroll();
    };
    const prevQuestion = () => {
        if (showReview) {
            let prevIndex = length - 1;
            setNav({
                showReview: false,
                prevDisabled: prevIndex < 1,
                currentIndex: prevIndex
            });
        } else {
            let prevIndex = !singlePage ? length - 1 : currentIndex - 1;
            setNav({
                prevDisabled: prevIndex < 1,
                nextDisabled: prevIndex === (length - 1),
                currentIndex: prevIndex,
            });
        }
        resetScroll();
    };
    const showRev = () => {
        setNav({
            showReview: true,
            currentIndex: length - 1
        });
        resetScroll();
    };
    useEffect(() => {
        const fetchData = async () => {
          const {quizId, userQuizId} = props
          const result = await instanceQuiz(quizId,userQuizId);
          setStoreIndex(result);
        };
     
        fetchData();
      }, []);

    useEffect(() => {
        const index = sessionStorage.getItem('currentIndex')
        if (storeIndex) {
            setNav({currentIndex: +storeIndex})
        }
        else if (index) {
            setNav({currentIndex: +index})
        }
    },[storeIndex])
    useEffect(() => {
        const {quizId, userQuizId}  = props
        props.changeCurrentIndex(currentIndex);
        sessionStorage.setItem('currentIndex', currentIndex)
        postInstance(quizId, currentIndex, userQuizId)
    }, [currentIndex]);
    useEffect(() => {
        props.showReviewPage(showReview);
    }, [showReview]);

    if (!singlePage && currentIndex !== length - 1) {
        setNav({currentIndex: length - 1, prevDisabled: prevDisabled, nextDisabled: nextDisabled, showReview: showReview});
    }

    const drawButtonGroup = () => {
        return (
            <ButtonGroup
                color="primary"
                aria-label="full-width contained primary button group"
                size="small"
            >
                <Button
                    onClick={prevQuestion}
                    disabled={prevDisabled || !singlePage}
                >
                    <ChevronLeft/>
                    {language === 'fr' ? 'Précédent' : 'Previous'}
                </Button>
                {currentIndex >= length - 1 ? (
                    <Button
                        onClick={showRev}
                        disabled={showReview === true}
                    >
                        {language === 'fr' ? 'Revoir' : 'Review'}
                        <ChevronRight/>
                    </Button>
                ) : (
                    <Button
                        onClick={nextQuestion}
                        disabled={nextDisabled || !singlePage}
                    >
                        {language === 'fr' ? 'Suivante' : 'Next'}
                        <ChevronRight/>
                    </Button>)}
            </ButtonGroup>
        );
    };
    const drawControls = () => {
        if (showReview) {
            return (
                <div className="quiz-nav-review">
                    <Button
                        color="secondary"
                        onClick={props.handleSubmit}
                        variant="outlined"
                        disabled={preview}
                    >
                        {language === 'fr' ? 'Soumettre' : 'Submit'}
                    </Button>
                    <div className="quiz-nav-spacer"/>
                    {drawButtonGroup()}
                </div>
            );
        } else {
            return (
                <div className="quiz-nav">
                    <div className="quiz-current-page">
                        {currentIndex + 1}/{length}
                    </div>
                    {drawButtonGroup()}
                </div>
            );
        }
    };
    return (
        <>
            {length > 0 && drawControls()}
        </>
    );
}
